import { useState, useRef } from "react"
import { default as ReactSelect, components } from "react-select"

const MultiSelect = props => {
  const [selectInput, setSelectInput] = useState("")
  const isAllSelected = useRef(false)
  const selectAllLabel = useRef("Select all")
  const allOption = { value: "*", label: selectAllLabel.current }

  const filterOptions = (options, input) =>
    options?.filter(({ label }) =>
      label.toLowerCase().includes(input.toLowerCase())
    )

  // const comparator = (v1, v2) => v1.value - v2.value

  let filteredOptions = filterOptions(props.options, selectInput)
  let filteredSelectedOptions = filterOptions(props.value, selectInput)

  const Option = props => (

    <components.Option {...props}  className="menu-list">
      {props.value === "*" &&
      !isAllSelected.current &&
      filteredSelectedOptions?.length > 0 ? (
        <input
          key={props.value}
          type="checkbox"
          className="checkbox"
          ref={input => {
            if (input) input.indeterminate = true
          }}
        />
      ) : (
        <input
          key={props.value}
          type="checkbox"
          checked={props.isSelected || isAllSelected.current}
          onChange={() => {}}
          className="checkbox"
        />
      )}
      <label style={{ marginLeft: "5px" }}>{props.label}</label>
    </components.Option>
  )

  const ValueContainer = ({ children, ...props }) => {
    let [values, input] = children;
    if (Array.isArray(values)) {
      const plural = values.length === 1 ? "" : "s";
      values = `${values.length} ${props?.selectProps?.id}${plural} selected`;
    }

    return (
      <components.ValueContainer {...props}>
        {values}
        {input}
      </components.ValueContainer>
    );
  };


  const Input = props => (
    <>
      {selectInput.length === 0 ? (
        <components.Input autoFocus={props.selectProps.menuIsOpen} {...props}  >
          {props.children}
        </components.Input>
      ) : (
        <div style={{ border: "1px dotted gray" }}>
          <components.Input autoFocus={props.selectProps.menuIsOpen} {...props}  >
            {props.children}
          </components.Input>
        </div>
      )}
    </>
  )

  const customFilterOption = ({ value, label }, input) =>
    (value !== "*" && label.toLowerCase().includes(input.toLowerCase())) ||
    (value === "*" && filteredOptions?.length > 0)

  const onInputChange = (inputValue, event) => {
    if (event.action === "input-change") setSelectInput(inputValue)
    else if (event.action === "menu-close" && selectInput !== "")
      setSelectInput("")
  }

  const onKeyDown = e => {
    if ((e.key === " " || e.key === "Enter") && !selectInput) e.preventDefault()
  }

  const handleChange = selected => {

    if (selected.length === props?.options?.length) {
      return props.onChange(props.options);
    }
    else if (selected.some((item) => item.value === "*") && !isAllSelected.current) {
      return props.onChange(props.options);
    } else if (selected.some((item) => item.value === "*") && isAllSelected.current) {
      return props.onChange([])
    }
    return props.onChange(selected);
  }

  const customStyles = {
    multiValueLabel: def => ({
      ...def,
      backgroundColor: "lightgray"
    }),
    multiValueRemove: def => ({
      ...def,
      backgroundColor: "lightgray"
    }),
    valueContainer: base => ({
      ...base,
      maxHeight: "65px",
      overflow: "auto"
    }),
    option: (styles, { isSelected, isFocused }) => {
      return {
        ...styles,
        backgroundColor:
          isSelected && !isFocused
            ? null
            : isFocused && !isSelected
            ? styles.backgroundColor
            : isFocused && isSelected
            ? "#DEEBFF"
            : null,
        color: isSelected ? null : null
      }
    },
    menu: def => ({ ...def, zIndex: 9999 })
  }
  if (props.isSelectAll && props.options?.length !== 0) {
    isAllSelected.current =
      JSON.stringify(filteredSelectedOptions) ===
      JSON.stringify(filteredOptions)

    if (filteredSelectedOptions?.length > 0) {
      if (filteredSelectedOptions?.length === filteredOptions?.length)
        selectAllLabel.current = `All (${filteredOptions.length}) selected`
      else
        selectAllLabel.current = `${filteredSelectedOptions?.length} / ${filteredOptions.length} selected`
    } else selectAllLabel.current = "Select all"

    allOption.label = selectAllLabel.current
    if(props.options)
    return (
      <ReactSelect
        {...props}
        inputValue={selectInput}
        onInputChange={onInputChange}
        onKeyDown={onKeyDown}
        options={[allOption, ...props.options]}
        onChange={handleChange}
        components={{
          Option: Option,
          Input: Input,
          ValueContainer,
          ...props.components
        }}
        filterOption={customFilterOption}
        menuPlacement={props.menuPlacement ?? "auto"}
        styles={customStyles}
        closeMenuOnSelect={false}
        tabSelectsValue={false}
        backspaceRemovesValue={false}
        hideSelectedOptions={false}
        blurInputOnSelect={false}
      />
    )
  }

  return (
    <div className="multiselect">
    <ReactSelect
      {...props}
      inputValue={selectInput}
      onInputChange={onInputChange}
      filterOption={customFilterOption}
      components={{
        Input: Input,
        ValueContainer,
        ...props.components
      }}
      menuPlacement={props.menuPlacement ?? "auto"}
      onKeyDown={onKeyDown}
      tabSelectsValue={false}
      hideSelectedOptions={true}
      backspaceRemovesValue={false}
      blurInputOnSelect={true}
      className="multiselect-dropdown"
    />
    </div>
  )
}

export default MultiSelect
